import { render, staticRenderFns } from "./Home_radical.vue?vue&type=template&id=1865e262&scoped=true&"
import script from "./Home_radical.vue?vue&type=script&lang=js&"
export * from "./Home_radical.vue?vue&type=script&lang=js&"
import style0 from "./Home_radical.vue?vue&type=style&index=0&id=1865e262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1865e262",
  null
  
)

export default component.exports